import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storeNames } from './config/config.type.ts';

interface SelectedSiteStore {
  /** Site chosen in the top bar. Undefined means "follow the configured default site". The id may
      point at a site the user can no longer reach (e.g. after switching cluster), so consumers must
      resolve it against the accessible-site list and fall back to the default site. */
  selectedSiteId?: string;
  setSelectedSiteId: (siteId?: string) => void;
}

export const useSelectedSiteStore = create(
  persist<SelectedSiteStore>(
    set => ({
      selectedSiteId: undefined,
      setSelectedSiteId: siteId =>
        set(state =>
          state.selectedSiteId === siteId ? state : { ...state, selectedSiteId: siteId }
        ),
    }),
    {
      name: storeNames.selectedSite,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
